import React from 'react';

const RelatedContentItem = ({item}) => (
  <div className="related--item">
    <div className="related--item--link">
      <a href={item.url} className="button__submit button__block">
        {item.name}
      </a>
    </div>
  </div>
);

export default RelatedContentItem;
